import axiosInstance from "./axiosInstance";
import { API_ENDPOINTS } from "./api/apiConfig";

export interface MedicalHistoryRequest {
  patientId: number;
  allergies?: string;
  chronicDiseases?: string;
  currentMedications?: string;
  pastSurgeries?: string;
  familyHistory?: string;
  pregnancyHistory?: string;
  substanceUse?: string;
  bloodType?: string;
  vaccinationHistory?: string;
  drugAllergies?: string;
  emergencyContactName?: string;
  emergencyContactPhone?: string;
}

export interface MedicalHistoryResponse {
  id: number;
  patientId: number;
  doctorId: number;
  medicalRecordId: number;
  antecedentsFamiliaux?: string;
  antecedentsPersonnels?: string;
  antecedentsChirurgicaux?: string;
  allergies?: string;
  traitementsEnCours?: string;
  habitudes?: string;
  autres?: string;
  createdAt: string;
  updatedAt: string;
}

class MedicalHistoryService {
  async createMedicalHistory(medicalHistoryData: MedicalHistoryRequest): Promise<MedicalHistoryResponse> {
    try {
      const response = await axiosInstance.post(
        API_ENDPOINTS.MEDICAL_HISTORY.BASE,
        medicalHistoryData
      );
      return response.data;
    } catch (error) {
      console.error("Error creating medical history:", error);
      if (error instanceof Error) {
        console.error("Error message:", error.message);
        console.error("Error response:", (error as any).response?.data);
        console.error("Error status:", (error as any).response?.status);
        console.error("Error config:", (error as any).config);
      }
      throw error;
    }
  }

  async getMedicalHistoryByPatient(patientId: number): Promise<MedicalHistoryResponse[]> {
    try {
      const response = await axiosInstance.get(
        API_ENDPOINTS.MEDICAL_HISTORY.BY_PATIENT(patientId)
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching medical history:", error);
      throw error;
    }
  }

  async getMedicalHistoryById(id: number): Promise<MedicalHistoryResponse> {
    try {
      const response = await axiosInstance.get(
        API_ENDPOINTS.MEDICAL_HISTORY.GET_BY_ID(id)
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching medical history:", error);
      throw error;
    }
  }

  async updateMedicalHistory(id: number, medicalHistoryData: Partial<MedicalHistoryRequest>): Promise<MedicalHistoryResponse> {
    try {
      const response = await axiosInstance.put(
        API_ENDPOINTS.MEDICAL_HISTORY.GET_BY_ID(id),
        medicalHistoryData
      );
      return response.data;
    } catch (error) {
      console.error("Error updating medical history:", error);
      throw error;
    }
  }

  async deleteMedicalHistory(id: number): Promise<void> {
    try {
      await axiosInstance.delete(
        API_ENDPOINTS.MEDICAL_HISTORY.GET_BY_ID(id)
      );
    } catch (error) {
      console.error("Error deleting medical history:", error);
      throw error;
    }
  }
}

export const medicalHistoryService = new MedicalHistoryService();
